import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const EventPartners = () => {
    const sliders = document.querySelectorAll('.event-partners__swiper');
    if (!sliders.length) return;

    // store swiper instances per element
    const swiperMap = new Map();

    function createSwiper(el) {
        const instance = new Swiper(el, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            speed: 0,
            allowTouchMove: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });

        swiperMap.set(el, instance);
    }

    function destroySwiper(el) {
        const instance = swiperMap.get(el);
        if (instance) {
            instance.destroy(true, true); // remove styles & events
            swiperMap.delete(el);
        }
    }

    function enableOrDisable() {
        const isDesktop = window.innerWidth >= 1024;

        sliders.forEach((slider) => {
            const hasInstance = swiperMap.has(slider);

            if (isDesktop && hasInstance) {
                // desktop: kill it
                destroySwiper(slider);
            }

            if (!isDesktop && !hasInstance) {
                // mobile/tablet: make it alive
                createSwiper(slider);
            }
        });
    }

    // run once now
    enableOrDisable();

    // run on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(enableOrDisable, 150);
    });
};

export default EventPartners;
